import { useState } from 'react'
import cx from 'classnames'
import { Modal, useModals } from 'almanac-ui/Modal'
import { Text } from 'blaze-ui/Text/Text'
import { ContentCategory, CONTENT_CATEGORIES, CONTENT_CATEGORY_CONFIG } from './Types'
import { CONTENT_CATEGORY_THUMBNAILS } from 'utils/brandPlans/contentCategories'
import Styles from './ContentTypeSelector.module.scss'

interface ContentTypeSelectorProps {
  onSelect: (category: ContentCategory) => void
}

export const ContentTypeSelector = ({ onSelect }: ContentTypeSelectorProps) => {
  const { closeModal } = useModals()
  const [selected, setSelected] = useState<ContentCategory | null>(null)

  const handleCardClick = (category: ContentCategory) => {
    setSelected(category)
  }

  return (
    <>
      <Modal.Header title="What type of content do you want to create?" />
      <Modal.Content>
        <div className={Styles.body}>
          <div className={Styles.grid}>
            {CONTENT_CATEGORIES.map((category) => {
              const config = CONTENT_CATEGORY_CONFIG[category]
              const isSelected = selected === category
              const thumbnail = CONTENT_CATEGORY_THUMBNAILS[category]

              return (
                <button
                  key={category}
                  type="button"
                  className={cx(Styles.card, { [Styles.selected]: isSelected })}
                  onClick={() => handleCardClick(category)}
                >
                  <div className={Styles.thumbnail}>
                    <img className={Styles.thumbnailImage} src={thumbnail} alt={config.label} />
                  </div>
                  <div className={Styles.cardText}>
                    <Text variant="largeList">{config.label}</Text>
                    <Text variant="metadata" color="var(--dark-40)">
                      {config.subtitle}
                    </Text>
                  </div>
                </button>
              )
            })}
          </div>
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton size="lg" variant="tertiary" onPress={closeModal}>
            Cancel
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton size="lg" isDisabled={!selected} onPress={() => selected && onSelect(selected)}>
            Continue to Post Details
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </>
  )
}
